export default ({ mutationField, movieId, movieListType }) => ({
    __typename: "Mutation",
    [mutationField]: {
        __typename: "ListMutationPayload",
        errors: [],
        movieId,
        movieListType,
    }
});


// WEBPACK FOOTER //
// ./src/mutations/listMutationOptimisticResponse.ts